







































































































































































































































    import { Component, Vue } from 'vue-property-decorator';
    import Forms from '@/components/Forms.vue';
    import {
        getCompany,
        postCompany,
        patchCompany,
        getCompanies,
        patchCompanyContactedAt, getBusinessDevelopers,
        getProgramDocsCommentAdmin,
        updateProgramDocsComment 
    } from '../api/api';
    import Company from '../models/Company';
    import { BACKEND_URL } from '../helpers/constants';
    import { legalForms } from '@/data/legalForms';
    import { companyTypes } from '../data/companyTypes';
    import get from 'lodash/get';
    import FileCurrent from '@/models/FileCurrent';
    import router from '@/router';
    import moment from 'moment';
    import User from '@/models/User';
    import AuthModule from '@/store/AuthModule';

    let company: Company | null = null;

    async function getCompanyForRouter(companyID: string) {
        try {
            const { data } = await getCompany(+companyID);
            return data;
        } catch (error) {
            console.warn(error, get(error, 'response.data.message'));
            return null;
        }
    }

    function getCompanyName(value: Company | null) {
        if (value) {
            return value.name;
        }
        return null;
    }

    @Component({
        beforeRouteEnter: async (to, from, next) => {
            const { route } = router.resolve({
                name: 'companies',
            });
            to.meta.breadcrumb[1].url = route.fullPath;

            if (to.params.id) {
                company = await getCompanyForRouter(to.params.id);

                if (company == null) {
                    Vue.prototype.$vs.notify({
                        color: 'danger',
                        position: 'top-right',
                        title: 'Erreur',
                        text: `Entreprise introuvable.`,
                    });

                    next({
                        name: 'companies',
                    });
                    return;
                } else {
                    to.meta.breadcrumb[2].title = getCompanyName(company);
                }
            }

            next();
        },
        beforeRouteUpdate: async (to, from, next) => {
            if (to.params.id) {
                company = await getCompanyForRouter(to.params.id);
                to.meta.breadcrumb[2].title = getCompanyName(company);
            }

            next();
        },
        components: {
            Forms,
        },
    })
    export default class CompanyForm extends Vue {
        title: string = '';
        company: Company | null = company;
        businessDeveloppers: Array<{ text: string; value: number }> = [];
        companiesItems: Array<{ text: string; value: number }> = [];
        methodesFlux:Array<{ text: string; value: string }> = [];
        loading: boolean = false;
        defaultImages: any | null = null;
        errors: any = {};
        apiSectionName = 'ESPACE DÉVELOPPEUR';
        fluxSectionName = "ESPACE FLUX";

        // Original comment properties for admin tracking
        originalComments: string = '';
        originalAdministrativeComment: string = '';
        originalBillingComments: string = '';
        originalRearMarginComments: string = '';
        originalDevComment: string = '';

        showGuide: boolean = false;

        toggleGuide() {
            this.showGuide = !this.showGuide;
        }

        form = {
    rear_margin_active: false,
    rear_margin_type: 'to_determine',
    rear_margin_rate: 0
    };

get rearMarginActive() {
    if (!this.company || !this.company.rear_margin) return false;
    return this.company.rear_margin !== null;
}

get rearMarginType() {
    if (!this.company || !this.company.rear_margin) return 'to_determine';
    if (this.company.rear_margin === 'to_determine') return 'to_determine';
    return 'multi_program';
}

get rearMarginRate() {
    if (!this.company || !this.company.rear_margin) return 0;
    if (this.company.rear_margin === 'to_determine') return 0;
    return parseFloat(this.company.rear_margin) || 0;
}

calculateRearMarginValue(form: any): string | undefined {
    // Si la marge arrière n'est pas active, ne pas envoyer le champ
    if (!form.rear_margin_active) return undefined;
    
    // Si le type est "à déterminer"
    if (form.rear_margin_type === 'to_determine') return 'to_determine';
    
    // Si le type est "multi_program" avec une valeur numérique
    if (form.rear_margin_type === 'multi_program' && form.rear_margin_rate !== undefined && form.rear_margin_rate !== null) {
        // Convertir simplement en string
        return String(form.rear_margin_rate);
    }
    
    // Par défaut, retourner undefined
    return undefined;
}

        // Comment processing methods - FIXED ALL 5 METHODS
// EXACT WORKING COMMENT METHODS FROM PRESCRIBERFORM - COPY THESE EXACTLY

// Replace your appendAdminComment method with this EXACT one:
            appendAdminComment(existingComment: string, adminComment: string): string {
                const userName = AuthModule.firstname || '';
                const userLastName = AuthModule.lastname || '';
                const fullName = (userName + ' ' + userLastName).trim();
                
                const now = new Date();
                const options = {
                    day: '2-digit' as const,
                    month: '2-digit' as const, 
                    year: 'numeric' as const,
                    hour: '2-digit' as const,
                    minute: '2-digit' as const,
                    timeZone: 'Europe/Paris'
                };
                const currentDateTime = now.toLocaleString('fr-FR', options);
                
                let newCommentBlock = '\n\n\n';
                
                if (fullName) {
                    newCommentBlock += 'MSG de ' + fullName + ' le ' + currentDateTime + ' :\n' + adminComment + '\n\n';
                } else {
                    newCommentBlock += 'MSG administrateur le ' + currentDateTime + ' :\n' + adminComment + '\n\n';
                }
                
                if (existingComment && existingComment.trim()) {
                    newCommentBlock += existingComment;
                }
                
                return newCommentBlock;
            }

            // Replace ALL your processXXXForSubmit methods with these EXACT ones:

            // For comments field
            processCommentsForSubmit(formComment: string): string {
                if (!formComment || !formComment.trim()) {
                    return '';
                }

                const cleanFormComment = formComment.trim();
                const cleanOriginalComment = this.originalComments ? this.originalComments.trim() : '';
                
                if (cleanFormComment === cleanOriginalComment) {
                    return formComment;
                }

                const adminCommentPattern = /Commentaire de .+ le \d{2}\/\d{2}\/\d{4}[^:]*:/;
                const firstAdminCommentIndex = formComment.search(adminCommentPattern);
                
                let newContent = '';
                if (firstAdminCommentIndex > 0) {
                    newContent = formComment.substring(0, firstAdminCommentIndex).trim();
                } else if (firstAdminCommentIndex === -1) {
                    newContent = cleanFormComment;
                }
                
                if (newContent && newContent !== cleanOriginalComment) {
                    if (newContent.replace(/[\s\n\r]/g, '').length > 0) {
                        return this.appendAdminComment(this.originalComments, newContent);
                    }
                }
                
                const formCommentNoSpaces = formComment.replace(/[\s\n\r]/g, '');
                const originalCommentNoSpaces = this.originalComments ? this.originalComments.replace(/[\s\n\r]/g, '') : '';
                
                if (formCommentNoSpaces === originalCommentNoSpaces) {
                    return this.originalComments || '';
                }
                
                return formComment;
            }

            // For administrative_comment field  
            processAdministrativeCommentForSubmit(formComment: string): string {
                if (!formComment || !formComment.trim()) {
                    return '';
                }

                const cleanFormComment = formComment.trim();
                const cleanOriginalComment = this.originalAdministrativeComment ? this.originalAdministrativeComment.trim() : '';
                
                if (cleanFormComment === cleanOriginalComment) {
                    return formComment;
                }

                const adminCommentPattern = /Commentaire de .+ le \d{2}\/\d{2}\/\d{4}[^:]*:/;
                const firstAdminCommentIndex = formComment.search(adminCommentPattern);
                
                let newContent = '';
                if (firstAdminCommentIndex > 0) {
                    newContent = formComment.substring(0, firstAdminCommentIndex).trim();
                } else if (firstAdminCommentIndex === -1) {
                    newContent = cleanFormComment;
                }
                
                if (newContent && newContent !== cleanOriginalComment) {
                    if (newContent.replace(/[\s\n\r]/g, '').length > 0) {
                        return this.appendAdminComment(this.originalAdministrativeComment, newContent);
                    }
                }
                
                const formCommentNoSpaces = formComment.replace(/[\s\n\r]/g, '');
                const originalCommentNoSpaces = this.originalAdministrativeComment ? this.originalAdministrativeComment.replace(/[\s\n\r]/g, '') : '';
                
                if (formCommentNoSpaces === originalCommentNoSpaces) {
                    return this.originalAdministrativeComment || '';
                }
                
                return formComment;
            }

            // For billing_comments field
            processBillingCommentsForSubmit(formComment: string): string {
                if (!formComment || !formComment.trim()) {
                    return '';
                }

                const cleanFormComment = formComment.trim();
                const cleanOriginalComment = this.originalBillingComments ? this.originalBillingComments.trim() : '';
                
                if (cleanFormComment === cleanOriginalComment) {
                    return formComment;
                }

                const adminCommentPattern = /Commentaire de .+ le \d{2}\/\d{2}\/\d{4}[^:]*:/;
                const firstAdminCommentIndex = formComment.search(adminCommentPattern);
                
                let newContent = '';
                if (firstAdminCommentIndex > 0) {
                    newContent = formComment.substring(0, firstAdminCommentIndex).trim();
                } else if (firstAdminCommentIndex === -1) {
                    newContent = cleanFormComment;
                }
                
                if (newContent && newContent !== cleanOriginalComment) {
                    if (newContent.replace(/[\s\n\r]/g, '').length > 0) {
                        return this.appendAdminComment(this.originalBillingComments, newContent);
                    }
                }
                
                const formCommentNoSpaces = formComment.replace(/[\s\n\r]/g, '');
                const originalCommentNoSpaces = this.originalBillingComments ? this.originalBillingComments.replace(/[\s\n\r]/g, '') : '';
                
                if (formCommentNoSpaces === originalCommentNoSpaces) {
                    return this.originalBillingComments || '';
                }
                
                return formComment;
            }

            // For rear_margin_comments field
            processRearMarginCommentsForSubmit(formComment: string): string {
                if (!formComment || !formComment.trim()) {
                    return '';
                }

                const cleanFormComment = formComment.trim();
                const cleanOriginalComment = this.originalRearMarginComments ? this.originalRearMarginComments.trim() : '';
                
                if (cleanFormComment === cleanOriginalComment) {
                    return formComment;
                }

                const adminCommentPattern = /Commentaire de .+ le \d{2}\/\d{2}\/\d{4}[^:]*:/;
                const firstAdminCommentIndex = formComment.search(adminCommentPattern);
                
                let newContent = '';
                if (firstAdminCommentIndex > 0) {
                    newContent = formComment.substring(0, firstAdminCommentIndex).trim();
                } else if (firstAdminCommentIndex === -1) {
                    newContent = cleanFormComment;
                }
                
                if (newContent && newContent !== cleanOriginalComment) {
                    if (newContent.replace(/[\s\n\r]/g, '').length > 0) {
                        return this.appendAdminComment(this.originalRearMarginComments, newContent);
                    }
                }
                
                const formCommentNoSpaces = formComment.replace(/[\s\n\r]/g, '');
                const originalCommentNoSpaces = this.originalRearMarginComments ? this.originalRearMarginComments.replace(/[\s\n\r]/g, '') : '';
                
                if (formCommentNoSpaces === originalCommentNoSpaces) {
                    return this.originalRearMarginComments || '';
                }
                
                return formComment;
            }

            // For dev_comment field
            processDevCommentForSubmit(formComment: string): string {
                if (!formComment || !formComment.trim()) {
                    return '';
                }

                const cleanFormComment = formComment.trim();
                const cleanOriginalComment = this.originalDevComment ? this.originalDevComment.trim() : '';
                
                if (cleanFormComment === cleanOriginalComment) {
                    return formComment;
                }

                const adminCommentPattern = /Commentaire de .+ le \d{2}\/\d{2}\/\d{4}[^:]*:/;
                const firstAdminCommentIndex = formComment.search(adminCommentPattern);
                
                let newContent = '';
                if (firstAdminCommentIndex > 0) {
                    newContent = formComment.substring(0, firstAdminCommentIndex).trim();
                } else if (firstAdminCommentIndex === -1) {
                    newContent = cleanFormComment;
                }
                
                if (newContent && newContent !== cleanOriginalComment) {
                    if (newContent.replace(/[\s\n\r]/g, '').length > 0) {
                        return this.appendAdminComment(this.originalDevComment, newContent);
                    }
                }
                
                const formCommentNoSpaces = formComment.replace(/[\s\n\r]/g, '');
                const originalCommentNoSpaces = this.originalDevComment ? this.originalDevComment.replace(/[\s\n\r]/g, '') : '';
                
                if (formCommentNoSpaces === originalCommentNoSpaces) {
                    return this.originalDevComment || '';
                }
                
                return formComment;
            }

            // Keep the prepareCommentForEditing method the same
            prepareCommentForEditing(originalComment: string): string {
                if (!originalComment || !originalComment.trim()) {
                    return '\n\n\n';
                }
                
                return '\n\n\n' + originalComment;
            }

        get type(): 'edit' | 'add' {
            return this.$route.name === 'addCompany' ? 'add' : 'edit';
        }

 
        get items() {
            return [
                {
                    name: 'image',
                    label: 'Logo entreprise',
                    type: 'image',
                    accept: 'image/png',
                },
                {
                    name: 'name',
                    label: "Nom de l'entreprise *",
                    type: 'text',
                    errorMessage: 'Le nom est requis',
                    required: true,
                },
                {
                    name: 'nb_of_stars',
                    label: "Note Promoteur",
                    type: 'number',
                    min: 0,
                    max: 5,
                    step: 1
                },
                {
                    name: 'promotor_note_comments',
                    label: "Commentaire Promoteur",
                    type: 'text',
                },
                {
                    name: 'email',
                    label: 'Email général *',
                    type: 'email',
                    errorMessage: "L'email est requis",
                    required: true,
                },
                {
                    name: 'legal_form',
                    label: 'Forme juridique',
                    type: 'select',
                    items: this.legalFormsArr,
                    placeholder: 'À renseigner',
                    errorMessage: 'La forme juridique est requise',
                },
                {
                    name: 'type',
                    label: "Type d'entreprise *",
                    type: 'select',
                    errorMessage: 'Le type est requis',
                    required: true,
                    items: this.companyTypesArr,
                },
                {
                    name: 'siret',
                    label: 'Siret',
                    type: 'text',
                },
                {
                    name: 'description',
                    label: 'Présentation promoteur (Affichée côté utilisateur)',
                    type: 'textarea',
                },
                {
                    name: 'holding',
                    label: 'Entreprise parente',
                    type: 'select',
                    items: [{ text: 'Aucune', value: '' }, ...this.companiesItems],
                },
                {
                    name: 'full_name_commercial_director',
                    label: 'Nom du directeur commercial',
                    type: 'text'
                },
                {
                    name: 'mail_commercial_director',
                    label: 'E-Mail du directeur commercial',
                    type: 'email'
                },
                {
                    name: 'phone_nb_commercial_director',
                    label: 'Tel Mobile Directeur Commercial',
                    type: 'text',
                },
                {
                  name: 'comments',
                  label: 'Commentaires service commercial (Chargé d\'Affaires)',
                  type: 'textarea',
                  maxLength: 1000000,
                },
                {
                  name: 'commercial_manager_name',
                  label: 'Nom du responsable des ventes',
                  type: 'text',
                },
                {
                    name: 'commercial_manager_email',
                    label: 'E-mail du responsable des ventes',
                    type: 'email',
                },
                {
                    name: 'commercial_manager_phone',
                    label: 'Tel fixe responsable ventes',
                    type: 'text',
                },
                {
                    name: 'commercial_manager_mobile',
                    label: 'Tel mobile responsable ventes',
                    type: 'text',
                },
                {
                    name: 'account_manager_name',
                    label: 'Nom du responsable comptabilité',
                    type: 'text',
                },
                {
                    name: 'account_manager_email',
                    label: 'E-mail du responsable comptabilité',
                    type: 'email',
                },
                {
                    name: 'account_manager_phone',
                    label: 'Tel fixe compta',
                    type: 'text',
                },
                {
                    name: 'account_manager_mobile',
                    label: 'Tel mobile compta',
                    type: 'text',
                },
                {
                  name: 'billing_comments',
                  label: 'Compta / Facturation',
                  type: 'textarea',
                  maxLength: 1000000,
                },
                {
                  name: 'rear_margin_comments',
                  label: 'Marge arrière / Prime sur Objectif',
                  type: 'textarea',
                  maxLength: 1000000,
                },
                {
                    name: 'url',
                    label: 'Site partenaire',
                    type: 'text',
                },
                {
                    name: 'login_site',
                    label: 'Login',
                    type: 'text',
                },
                {
                    name: 'password_site',
                    label: 'Mot de passe',
                    type: 'text',
                },
                {
                    name: 'bic',
                    label: 'BIC',
                    type: 'text',
                },
                {
                    name: 'rcs',
                    label: 'RCS',
                    type: 'text',
                },
                {
                    name: 'share_capital',
                    label: 'Capital social',
                    type: 'text',
                },
                {
                    name: 'address_street',
                    label: 'Adresse (ligne 1) *',
                    type: 'text',
                    errorMessage: "L'adresse est requise",
                    required: true,
                },
                {
                    name: 'address_street2',
                    label: 'Adresse (ligne 2)',
                    type: 'text',
                },
                {
                    name: 'address_postal_code',
                    label: 'Code postal *',
                    type: 'text',
                    errorMessage: 'Le code postal est requis',
                    required: true,
                },
                {
                    name: 'address_city',
                    label: 'Ville *',
                    type: 'text',
                    errorMessage: 'La ville est requise',
                    required: true,
                },
                {
                    name: 'fax',
                    label: 'Fax',
                    type: 'text',
                },
                {
                    name: 'phone',
                    label: 'Téléphone',
                    type: 'text',
                },
                {
                    name: 'mobile',
                    label: 'Mobile',
                    type: 'text',
                },
                {
                    name: 'business_developper',
                    label: 'Développeur commercial',
                    type: 'select',
                    items: this.businessDeveloppers,
                    required: true,
                },

                                {
                  name: 'seller_infos',
                  label: 'Infos Vendeur (Affichées côté utilisateur)',
                  type: 'textarea'
                },
                
                


                  {
                    name: 'booking_instructions',
                    label: 'Consignes particulières pour Dénoncer, Optionner et Réserver',
                    type: 'textarea',
                },


                {
                    name: 'administrative_comment',
                    label: 'Commentaires BackOffice',
                    type: 'textarea',
                    maxLength: 1000000,
                },
                {
                    name: 'rear_margin_active',
                    label: 'Marge Arrière',
                    type: 'switch',
                },
                {
                    name: 'rear_margin_type',
                    label: '',
                    type: 'select',
                    items: [
                        { text: 'À déterminer', value: 'to_determine' },
                        { text: 'Multi-programme', value: 'multi_program' }
                    ],
                    requires: ['rear_margin_active', true],
                    custom: {
                        component: 'rear-margin-control',
                        props: {
                            form: this.form
                        }
                    }
                },
                {
                    name: 'rear_margin_rate',
                    label: '',
                    type: 'number',
                    min: 0,
                    max: 1,
                    step: 0.01,
                    requires: [
                        ['rear_margin_active', true],
                        ['rear_margin_type', 'multi_program']
                    ],
                    custom: {
                        component: 'rear-margin-control',
                        props: {
                            form: this.form
                        }
                    }
                },
                {
                    name: 'electronic_signature_mandate',
                    label: 'Signature électronique mandat',
                    type: 'select',
                    items: [
                        { text: 'En attente', value: 'pending' },
                        { text: 'OK', value: 'ok' },
                        { text: 'Non', value: 'no' },
                    ],
                },
                {
                    name: 'electronic_signature_contract',
                    label: 'Signature électronique contrat',
                    type: 'select',
                    items: [
                        { text: 'En attente', value: 'pending' },
                        { text: 'OK', value: 'ok' },
                        { text: 'Non', value: 'no' },
                    ],
                },
                {
                    name: 'paper_signature_contract',
                    label: 'Signature papier contrat',
                    type: 'select',
                    items: [
                        { text: 'En attente', value: 'pending' },
                        { text: 'OK', value: 'ok' },
                        { text: 'Non', value: 'no' },
                    ],
                },
                {
                    name: 'crm',
                    label: 'CRM',
                    type: 'select',
                    items: [
                        { text: 'À déterminer', value: '' },
                        { text: 'Oui', value: 'yes' },
                        { text: 'Non', value: 'no' },
                    ],
                },
                {
                    name: 'supplier',
                    label: 'Fournisseur',
                    type: 'text',
                    requires: ['crm', 'yes'],
                },
                {
                    name: 'is_multi_fee',
                    label: 'Honoraires HT',
                    type: 'select',
                    items: [
                        { text: 'À déterminer', value: '' },
                        { text: 'Multi-programme', value: 'yes' },
                        { text: 'Par programme', value: 'no' },
                    ],
                },
                {
                    name: 'duty_free_fee',
                    label: 'Honoraires (%)',
                    type: 'number',
                    requires: ['is_multi_fee', 'yes'],
                },
                {
                    name: 'multi_boost',
                    label: 'Boost Commercial',
                    type: 'select',
                    items: [
                        { text: 'À déterminer', value: '' },
                        { text: 'Multi-programme', value: 'yes' },
                        { text: 'Par programme', value: 'no' },
                    ],
                },
                {
                    name: 'boost_due_date_prescriber',
                    label: 'Date Limite boost hono.',
                    type: 'date',
                    requires: ['multi_boost', 'yes'],
                },
                {
                    name: 'boost_comment_prescriber',
                    label: 'Commentaire boost hono.',
                    type: 'textarea',
                    requires: ['multi_boost', 'yes'],
                },
                {
                  name: 'boost_due_date_customer',
                  label: 'Date Limite avant. client',
                  type: 'date',
                  requires: ['multi_boost', 'yes'],
                },
                {
                    name: 'boost_comment_customer',
                    label: 'Commentaire avant. client',
                    type: 'textarea',
                    requires: ['multi_boost', 'yes'],
                },
                {
                    name: 'is_boost_prescriber',
                    label: 'Boost hono.',
                    type: 'switch',
                    requires: ['multi_boost', 'yes'],
                },
                {
                    name: 'is_boost_customer',
                    label: 'Avant. client',
                    type: 'switch',
                    requires: ['multi_boost', 'yes'],
                },
                {
                    name: 'is_multi_mandat',
                    label: 'Mandat prélèvement',
                    type: 'select',
                    items: [
                        { text: 'À déterminer', value: '' },
                        { text: 'Multi-programmes', value: 'yes' },
                        { text: 'Par programme', value: 'no' },
                    ],
                },
                {
                    name: 'mandat_num_mandat',
                    label: 'N° Mandat',
                    type: 'text',
                    requires: ['is_multi_mandat', 'yes'],
                },
                {
                    name: 'mandat_date_due',
                    label: 'Date d\'écheance',
                    type: 'date',
                    requires: ['is_multi_mandat', 'yes'],
                },
                {
                    name: 'mandat_mandat_file',
                    label: 'Fichier mandat signé',
                    type: 'custom-file',
                    requires: ['is_multi_mandat', 'yes'],
                    current: 'mandat_mandat_file_current',
                    fields: {
                        name: 'mandat_mandat_file_name',
                        content: 'mandat_mandat_file',
                    },
                },
                /* API */
                {
                    name: 'api_available',
                    label: 'Espace partenaire',
                    type: 'switch',
                    section: this.apiSectionName,
                    sectionChunked: false,
                },
                {
                    name: 'api_connected',
                    label: 'Connecté',
                    type: 'switch',
                    requires: ['api_available', true],
                    section: this.apiSectionName,
                    sectionChunked: false,
                },
                {
                    name: 'api_documentation',
                    label: 'Documentation API (PDF)',
                    type: 'custom-file',
                    current: 'api_documentation_current',
                    fields: {
                        name: 'api_documentation_name',
                        content: 'api_documentation',
                    },
                    requires: ['api_available', true],
                    section: this.apiSectionName,
                    sectionChunked: false,
                },
                {
                    name: 'api_documentation2',
                    label: 'Documentation API n°2 (PDF)',
                    type: 'custom-file',
                    current: 'api_documentation2_current',
                    fields: {
                        name: 'api_documentation2_name',
                        content: 'api_documentation2',
                    },
                    requires: ['api_available', true],
                    section: this.apiSectionName,
                    sectionChunked: false,
                },
                {
                    name: 'api_documentation3',
                    label: 'Documentation API n°3 (PDF)',
                    type: 'custom-file',
                    current: 'api_documentation3_current',
                    fields: {
                        name: 'api_documentation3_name',
                        content: 'api_documentation3',
                    },
                    requires: ['api_available', true],
                    section: this.apiSectionName,
                    sectionChunked: false,
                },
                {
                    name: 'dev_comment',
                    label: 'Commentaire dev',
                    type: 'textarea',
                    maxLength: 1000000,
                    section: this.apiSectionName,
                    sectionChunked: false,
                },
                //FLUX
                {
                    name: 'flux_methode',
                    label: 'Méthode de Flux',
                    type: 'select',
                    items: this.methodesFlux,
                    required: false,
                    section: this.fluxSectionName,
                    sectionChunked: false,
                }
            ];
        }


        value: any | null = null;


        defaultValue: any = {
            name: null,
            description: null,
            holding: '',
            commercial_manager: null,
            type: null,
            url: null,
            login_site: null,
            password_site: null,
            siret: null,
            legal_form: null,
            email: null,
            address_street: null,
            address_street2: null,
            address_postal_code: null,
            address_city: null,
            comments: null,
            full_name_commercial_director: null,
            mail_commercial_director: null,
            phone_nb_commercial_director: null,
            commercial_manager_name: null,
            commercial_manager_email: null,
            commercial_manager_phone: null,
            commercial_manager_mobile: null,
            account_manager_name: null,
            account_manager_email: null,
            account_manager_phone: null,
            account_manager_mobile: null,
            nb_total_programs: 0,
            nb_programs_to_enter: 0,
            public_site_url: null,
            seller_infos: null,
            heart_stroke: null,
            denounce_method: null,
            option_method: null,
            booking_method: null,
            administrative_comment: null,
            billing_comments: null,
            electronic_signature_mandate: null,
            electronic_signature_contract: null,
            paper_signature_contract: null,
            crm: '',
            supplier: null,
            is_multi_fee: '',
            duty_free_fee: null,
            multi_boost: '',
            promotor_note_comments: null,
            rear_margin_comments: null,
            rear_margin_active: false,
            rear_margin_type: 'to_determine',
            rear_margin_rate: 0,
            nb_of_stars: null,
            boost_due_date_prescriber: null,
            boost_due_date_customer: null,
            boost_comment_prescriber: null,
            boost_comment_customer: null,
            is_boost_prescriber: null,
            is_boost_customer: null,
            is_multi_mandat: '',
            business_developper: null,
            bic: null,
            rcs: null,
            share_capital: null,
            fax: null,
            phone: null,
            mobile: null,
            booking_instructions: null,
            api_available: null,
            api_connected: null,
            dev_comment: null,
            mandat_num_mandat: null,
            mandat_date_due: null,
            mandat_mandat_file: null,
            mandat_mandat_file_name: null,
            mandat_mandat_file_current: null,
            flux_methode: null,
            brochure_file: null,
            brochure_filename: null,
            booking_doc_file: null,
            booking_doc_filename: null,
        };
        



        async mounted() {
            this.loading = true;
            const dataBusinessDeveloppers = await getBusinessDevelopers();
            const dataCompanies = await getCompanies();

            this.businessDeveloppers = dataBusinessDeveloppers.data.map(
                (item: User) => ({
                    text: item.firstname + " - " + item.email,
                    value: item.id || 0,
                })
            );

            this.methodesFlux = [
                {
                    text: 'Aucun',
                    value: ''
                },
                {
                    text: 'API',
                    value: 'api'
                },
                {
                    text: 'Email',
                    value: 'email'
                },
                {
                    text: 'Interface web',
                    value: 'web_interface'
                },
                {
                    text: 'Sftp',
                    value: 'sftp'
                }
            ];

            this.companiesItems = dataCompanies.data.map((company: Company) => ({
                value: company.id,
                text: company.name,
            }));

            if (this.type === 'edit') {
                await this.loadCompany();
            } else {
                this.loading = false;
            }
        }
        

      

        async loadCompany() {
                try {
                    const { data } = await getCompany(+this.$route.params.id);

                    this.company = data;

                    if (this.company) {
                        this.defaultValue.name = this.company.name || null;
                        this.defaultValue.image = null;
                        this.defaultValue.description = this.company.description || null;
                        this.defaultValue.holding = this.company.holding
                            ? this.company.holding.id
                            : '';
                        this.defaultValue.type = this.company.type || null;
                        this.defaultValue.url = this.company.url || null;
                        this.defaultValue.login_site = this.company.login_site || null;
                        this.defaultValue.password_site =
                            this.company.password_site || null;
                        this.defaultValue.siret = this.company.siret || null;
                        this.defaultValue.legal_form = this.company.legal_form || null;
                        this.defaultValue.full_name_commercial_director = this.company.full_name_commercial_director || null;
                        this.defaultValue.mail_commercial_director = this.company.mail_commercial_director || null;
                        this.defaultValue.phone_nb_commercial_director = this.company.phone_nb_commercial_director || null;
                        this.defaultValue.email = this.company.email || null;
                        this.defaultValue.fax = this.company.fax || null;
                        this.defaultValue.phone = this.company.phone || null;
                        this.defaultValue.mobile = this.company.mobile || null;
                        this.defaultValue.address_street =
                            (this.company.address && this.company.address.street) || null;
                        this.defaultValue.address_street2 =
                            (this.company.address && this.company.address.street2) || null;
                        this.defaultValue.address_postal_code =
                            (this.company.address && this.company.address.postal_code) ||
                            null;
                        this.defaultValue.address_city =
                            (this.company.address && this.company.address.city) || null;
                        
                        // Process comments with admin tracking
                        const originalComments = this.company.comments || '';
                        this.originalComments = originalComments;
                        this.defaultValue.comments = this.prepareCommentForEditing(originalComments);
                        
                        this.defaultValue.commercial_manager_name =
                            this.company.commercial_manager_name || null;
                        this.defaultValue.commercial_manager_email =
                            this.company.commercial_manager_email || null;
                        this.defaultValue.commercial_manager_phone =
                            this.company.commercial_manager_phone || null;
                        this.defaultValue.commercial_manager_mobile =
                            this.company.commercial_manager_mobile || null;
                        this.defaultValue.account_manager_name =
                            this.company.account_manager_name || null;
                        this.defaultValue.account_manager_email =
                            this.company.account_manager_email || null;
                        this.defaultValue.account_manager_phone =
                            this.company.account_manager_phone || null;
                        this.defaultValue.account_manager_mobile =
                            this.company.account_manager_mobile || null;
                        this.defaultValue.nb_total_programs =
                            this.company.nb_total_programs || 0;
                        this.defaultValue.nb_programs_to_enter =
                            this.company.nb_programs_to_enter || 0;
                        this.defaultValue.public_site_url =
                            this.company.public_site_url || null;
                        this.defaultValue.seller_infos = this.company.seller_infos || null;
                        this.defaultValue.heart_stroke = this.company.heart_stroke || null;
                        this.defaultValue.denounce_method = this.company.denounce_method || null;
                        this.defaultValue.option_method = this.company.option_method || null;
                        this.defaultValue.booking_method = this.company.booking_method || null;
                        
                        // Process administrative_comment with admin tracking
                        const originalAdministrativeComment = this.company.administrative_comment || '';
                        this.originalAdministrativeComment = originalAdministrativeComment;
                        this.defaultValue.administrative_comment = this.prepareCommentForEditing(originalAdministrativeComment);
                        
                        // Process billing_comments with admin tracking
                        const originalBillingComments = this.company.billing_comments || '';
                        this.originalBillingComments = originalBillingComments;
                        this.defaultValue.billing_comments = this.prepareCommentForEditing(originalBillingComments);
                        
                        this.defaultValue.electronic_signature_mandate =
                            this.company.electronic_signature_mandate || 'pending';
                        this.defaultValue.electronic_signature_contract =
                            this.company.electronic_signature_contract || 'pending';
                        this.defaultValue.paper_signature_contract =
                            this.company.paper_signature_contract || null;
                        this.defaultValue.crm = this.company.crm || '';
                        this.defaultValue.supplier = this.company.supplier || '';
                        this.defaultValue.is_multi_fee = this.company.is_multi_fee || '';
                        this.defaultValue.duty_free_fee = this.company.duty_free_fee || '';
                        this.defaultValue.multi_boost = this.company.multi_boost || '';
                        this.defaultValue.promotor_note_comments = this.company.promotor_note_comments || null;
                        
                        // Process rear_margin_comments with admin tracking
                        const originalRearMarginComments = this.company.rear_margin_comments || '';
                        this.originalRearMarginComments = originalRearMarginComments;
                        this.defaultValue.rear_margin_comments = this.prepareCommentForEditing(originalRearMarginComments);
                        
                        this.defaultValue.rear_margin_active = this.rearMarginActive;
                        this.defaultValue.rear_margin_type = this.rearMarginType;
                        this.defaultValue.rear_margin_rate = this.rearMarginRate;
                        this.form.rear_margin_active = this.rearMarginActive;
                        this.form.rear_margin_type = this.rearMarginType;
                        this.form.rear_margin_rate = this.rearMarginRate;
                        this.defaultValue.booking_instructions = this.company.booking_instructions || null;
                        this.defaultValue.nb_of_stars = this.company.nb_of_stars || null;
                        this.defaultValue.boost_due_date_prescriber =
                            (this.company.boost_due_date_prescriber &&
                                moment(this.company.boost_due_date_prescriber)) ||
                            null;
                        this.defaultValue.boost_due_date_customer =
                            (this.company.boost_due_date_customer &&
                                moment(this.company.boost_due_date_customer)) ||
                            null;
                        this.defaultValue.boost_comment_prescriber =
                            this.company.boost_comment_prescriber || '';
                        this.defaultValue.boost_comment_customer =
                            this.company.boost_comment_customer || '';
                        this.defaultValue.is_boost_prescriber =
                            this.company.is_boost_prescriber || false;
                        this.defaultValue.is_boost_customer =
                            this.company.is_boost_customer || false;
                        this.defaultValue.is_multi_mandat =
                            this.company.is_multi_mandat || '';
                        this.defaultValue.business_developper = this.company.business_developper ?
                            this.company.business_developper.id : null;

                        // API
                        this.defaultValue.api_available =
                            this.company.api_available || null;
                        this.defaultValue.api_connected =
                            this.company.api_connected || null;
                        
                        // Process dev_comment with admin tracking
                        const originalDevComment = this.company.dev_comment || '';
                        this.originalDevComment = originalDevComment;
                        this.defaultValue.dev_comment = this.prepareCommentForEditing(originalDevComment);
                        
                        this.defaultValue.mandat_num_mandat = this.company.mandat
                            ? this.company.mandat.num_mandat
                            : null;
                        this.defaultValue.mandat_date_due = this.company.mandat
                            ? moment(this.company.mandat.date_due)
                            : null;

                        // FLUX
                        this.defaultValue.flux_methode = this.company.flux_methode || null;

                        // ✅ FILE INPUTS - FIXED: Only set the _current properties, never the file input itself
                        
                        // API documentation 1
                        if (this.company.api_documentation) {
                            const current: FileCurrent = {
                                name: `${this.company.api_documentation.name}.${this.company.api_documentation.extension}`,
                                url: `${BACKEND_URL}${this.company.api_documentation.url}${this.company.api_documentation.name}.${this.company.api_documentation.extension}`,
                            };
                            this.defaultValue.api_documentation_current = current;
                        }

                        // API documentation 2
                        if (this.company.api_documentation2) {
                            const current: FileCurrent = {
                                name: `${this.company.api_documentation2.name}.${this.company.api_documentation2.extension}`,
                                url: `${BACKEND_URL}${this.company.api_documentation2.url}${this.company.api_documentation2.name}.${this.company.api_documentation2.extension}`,
                            };
                            this.defaultValue.api_documentation2_current = current;
                        }

                        // API documentation 3
                        if (this.company.api_documentation3) {
                            const current: FileCurrent = {
                                name: `${this.company.api_documentation3.name}.${this.company.api_documentation3.extension}`,
                                url: `${BACKEND_URL}${this.company.api_documentation3.url}${this.company.api_documentation3.name}.${this.company.api_documentation3.extension}`,
                            };
                            this.defaultValue.api_documentation3_current = current;
                        }

                        // Brochure
                        if (this.company.brochure) {
                            const current: FileCurrent = {
                                name: `${this.company.brochure.name}.${this.company.brochure.extension}`,
                                url: `${BACKEND_URL}${this.company.brochure.url}${this.company.brochure.name}.${this.company.brochure.extension}`,
                            };
                            this.defaultValue.brochure_current = current;
                        }

                        // Booking document
                        if (this.company.booking_doc) {
                            const current: FileCurrent = {
                                name: `${this.company.booking_doc.name}.${this.company.booking_doc.extension}`,
                                url: `${BACKEND_URL}${this.company.booking_doc.url}${this.company.booking_doc.name}.${this.company.booking_doc.extension}`,
                            };
                            this.defaultValue.booking_doc_current = current;
                        }

                        // Mandat file
                        if (this.company.mandat && this.company.mandat.mandat_file) {
                            const current: FileCurrent = {
                                name: `${this.company.mandat.mandat_file.name}.${this.company.mandat.mandat_file.extension}`,
                                downloadMandat: this.company,
                            };
                            this.defaultValue.mandat_mandat_file_current = current;
                        }
                    }
                    
                    this.loading = false;

                    // Load docs comment separately with error handling
                    if (this.type === 'edit') {
                        try {
                            await this.loadDocsComment();
                        } catch (error) {
                            console.error('Failed to load docs comment, continuing anyway:', error);
                            // Don't block the form from loading
                        }
                    }
                } catch (error) {
                    console.error('Error loading company:', error);
                    this.loading = false;
                    
                    const $vs = (this as any).$vs;
                    $vs.notify({
                        color: 'danger',
                        position: 'top-right',
                        title: 'Erreur',
                        text: 'Impossible de charger les données de l\'entreprise',
                    });
                    
                    this.$router.push({ name: 'companies' });
                }
            }




        saveLastUpdate() {
            if (this.company != null) {
                patchCompanyContactedAt(this.company.id as number)
                    .then(resp => {
                        const $vs = (this as any).$vs;
                        $vs.notify({
                            color: 'success',
                            position: 'top-right',
                            title: 'Modification',
                            text: `Dernière mis à jour enregistrée`,
                        });
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        }



        async submit(form: any) {
    this.loading = true;
    
    // Nettoyer les données du formulaire
    const cleanedForm = this.cleanFormData(form);
    
    /**
     * when we click on the cross it didn't clear the holding if this code is not here
     */
    if(typeof cleanedForm.holding == 'undefined') {
      cleanedForm.holding = '';
    }
    
    // FIXED: Process comments with admin tracking - ALL 5 FIELDS
    const processedComments = this.processCommentsForSubmit(form.comments);
    const processedAdministrativeComment = this.processAdministrativeCommentForSubmit(form.administrative_comment);
    const processedBillingComments = this.processBillingCommentsForSubmit(form.billing_comments);
    const processedRearMarginComments = this.processRearMarginCommentsForSubmit(form.rear_margin_comments);
    const processedDevComment = this.processDevCommentForSubmit(form.dev_comment);
    
    // Calculer la valeur de rear_margin basée sur les champs de l'interface
    const rearMarginValue = this.calculateRearMarginValue(form); // Utiliser form original pour le calcul
        console.log('Form rear_margin_active:', form.rear_margin_active);
    console.log('Form rear_margin_type:', form.rear_margin_type);
    console.log('Form rear_margin_rate:', form.rear_margin_rate);
    console.log('Calculated rear_margin value:', rearMarginValue);
    const newCompany: Company = {
        name: cleanedForm.name,
        image: cleanedForm.image,
        description: cleanedForm.description,
        type: cleanedForm.type,
        nb_of_stars: cleanedForm.nb_of_stars,
        promotor_note_comments: cleanedForm.promotor_note_comments,
        holding: cleanedForm.holding,
        url: cleanedForm.url,
        login_site: cleanedForm.login_site,
        password_site: cleanedForm.password_site,
        siret: cleanedForm.siret,
        email: cleanedForm.email,
        bic: cleanedForm.bic,
        full_name_commercial_director: cleanedForm.full_name_commercial_director,
        mail_commercial_director: cleanedForm.mail_commercial_director,
        phone_nb_commercial_director: cleanedForm.phone_nb_commercial_director,
        legal_form: cleanedForm.legal_form || '',
        rcs: cleanedForm.rcs,
        share_capital: cleanedForm.share_capital,
        fax: cleanedForm.fax,
        phone: cleanedForm.phone,
        mobile: cleanedForm.mobile,
        address: {
            street: cleanedForm.address_street,
            street2: cleanedForm.address_street2,
            postal_code: cleanedForm.address_postal_code,
            city: cleanedForm.address_city,
        },
        nb_total_programs: cleanedForm.nb_total_programs,
        nb_programs_to_enter: cleanedForm.nb_programs_to_enter,
        public_site_url: cleanedForm.public_site_url,
        electronic_signature_mandate: cleanedForm.electronic_signature_mandate,
        electronic_signature_contract: cleanedForm.electronic_signature_contract,
        paper_signature_contract: cleanedForm.paper_signature_contract,
        comments: processedComments,  // FIXED: Use processed
        seller_infos: cleanedForm.seller_infos,
        heart_stroke: cleanedForm.heart_stroke,
        administrative_comment: processedAdministrativeComment,  // FIXED: Use processed
        billing_comments: processedBillingComments,  // FIXED: Use processed
        commercial_manager_name: cleanedForm.commercial_manager_name,
        commercial_manager_email: cleanedForm.commercial_manager_email,
        commercial_manager_phone: cleanedForm.commercial_manager_phone,
        commercial_manager_mobile: cleanedForm.commercial_manager_mobile,
        account_manager_name: cleanedForm.account_manager_name,
        account_manager_email: cleanedForm.account_manager_email,
        account_manager_phone: cleanedForm.account_manager_phone,
        account_manager_mobile: cleanedForm.account_manager_mobile,
        crm: cleanedForm.crm,
        supplier: cleanedForm.crm === 'yes' ? cleanedForm.supplier : '',
        is_multi_fee: cleanedForm.is_multi_fee,
        duty_free_fee: cleanedForm.is_multi_fee === 'yes' ? cleanedForm.duty_free_fee : 0,
        business_developper: cleanedForm.business_developper,
        multi_boost: cleanedForm.multi_boost,
        boost_due_date_prescriber:
            cleanedForm.multi_boost === 'yes'
                ? cleanedForm.boost_due_date_prescriber
                : '',
        boost_due_date_customer:
            cleanedForm.multi_boost === 'yes' ? cleanedForm.boost_due_date_customer : '',
        boost_comment_prescriber:
            cleanedForm.multi_boost === 'yes' ? cleanedForm.boost_comment_prescriber : '',
        boost_comment_customer:
            cleanedForm.multi_boost === 'yes' ? cleanedForm.boost_comment_customer : '',
        is_boost_prescriber:
            cleanedForm.multi_boost === 'yes' ? cleanedForm.is_boost_prescriber : '',
        is_boost_customer:
            cleanedForm.multi_boost === 'yes' ? cleanedForm.is_boost_customer : '',
        is_multi_mandat: cleanedForm.is_multi_mandat,
        mandat:
            cleanedForm.is_multi_mandat !== 'yes'
                ? undefined
                : {
                    num_mandat: cleanedForm.mandat_num_mandat,
                    date_due: cleanedForm.mandat_date_due,
                    mandat_file: cleanedForm.mandat_mandat_file,
                },

        // api
        api_available: cleanedForm.api_available,
        api_connected: cleanedForm.api_connected,
        dev_comment: processedDevComment,  // FIXED: Use processed

        //flux
        flux_methode: cleanedForm.flux_methode,

        // api documentation
        document: cleanedForm.document,
        document_name: cleanedForm.document_name,
        document2: cleanedForm.document2,
        document2_name: cleanedForm.document2_name,
        document3: cleanedForm.document3,
        document3_name: cleanedForm.document3_name,
        brochure_file: cleanedForm.brochure_file,
        brochure_filename: cleanedForm.brochure_filename,
        booking_doc_file: cleanedForm.booking_doc_file,
        booking_doc_filename: cleanedForm.booking_doc_filename,
        rear_margin_comments: processedRearMarginComments,  // FIXED: Use processed
        rear_margin: rearMarginValue, // Utiliser la valeur calculée
        booking_instructions: cleanedForm.booking_instructions,
        denounce_method: cleanedForm.denounce_method,
        option_method: cleanedForm.option_method,
        booking_method: cleanedForm.booking_method,
    };

    const $vs = (this as any).$vs;
    try {
        if (this.type === 'add') {
            await postCompany(newCompany);
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Création',
                text: `Création de l'entreprise réussie`,
            });
        } else {
            await patchCompany(+this.$route.params.id, newCompany);
            // FIXED: Update original comments for next edits - ALL 5 FIELDS
            this.originalComments = processedComments;
            this.originalAdministrativeComment = processedAdministrativeComment;
            this.originalBillingComments = processedBillingComments;
            this.originalRearMarginComments = processedRearMarginComments;
            this.originalDevComment = processedDevComment;
            
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Modification',
                text: `Modification de l'entreprise réussie`,
            });
        }
        this.$router.push({ name: 'companies' });
    } catch (error) {
        this.errors = get(error, 'response.data.errors.children', {});

        const message = get(
            error,
            'response.data.message',
            'Erreur lors de la soumission du formulaire'
        );
        $vs.notify({
            color: 'danger',
            position: 'top-right',
            title: 'Erreur',
            text: message,
        });
    } finally {
        this.loading = false;
    }
}



        get legalFormsArr() {
            return Object.keys(legalForms).map(key => ({
                text: (legalForms as any)[key],
                value: key,
            }));
        }

        cleanFormData(form: any): any {
    // Créer une copie de l'objet form pour ne pas modifier l'original
    const cleanedForm = { ...form };
    
    // Supprimer les champs qui ne doivent pas être envoyés à l'API
    delete cleanedForm.rear_margin_active;
    delete cleanedForm.rear_margin_type;
    delete cleanedForm.rear_margin_rate;
    delete cleanedForm.rear_margin_rate_control; // Au cas où ce champ serait présent
    delete cleanedForm.targetView; // Ce champ est aussi ajouté par Forms.vue
    
    return cleanedForm;
}

        get companyTypesArr() {
            return Object.keys(companyTypes).map(key => ({
                text: (companyTypes as any)[key],
                value: key,
            }));
        }

        // Partie Commentaire
        docsCommentText: string = '';
        isSavingDocsComment: boolean = false;


        async loadDocsComment() {
            // Only load in edit mode
            const companyId = (this.company && this.company.id) || +this.$route.params.id;
            
            if (!companyId) {
                return;
            }
            
            try {
                const { data } = await getProgramDocsCommentAdmin(companyId);
                
                // Safely handle the response
                if (data && typeof data.docs_comment === 'string') {
                    this.docsCommentText = data.docs_comment;
                } else {
                    // Initialize with empty string if no comment exists
                    this.docsCommentText = '';
                }
            } catch (error) {
                console.error('Error loading docs comment:', error);
                // Don't throw - just initialize with empty string
                this.docsCommentText = '';
            
            }
}


getValue(val: any) {
    this.value = val;
}


async saveDocsComment() {
    // Vérifier qu'on a bien un ID de company (mode edit uniquement)
    const companyId = (this.company && this.company.id) || +this.$route.params.id;
    
    if (!companyId) {
        (this as any).$vs.notify({
            color: 'warning',
            position: 'top-right',
            title: 'Attention',
            text: 'Veuillez d\'abord enregistrer l\'entreprise',
        });
        return;
    }

    this.isSavingDocsComment = true;

    try {
        // Supprimer l'ancienne date de MAJ si elle existe
        let cleanComment = this.docsCommentText.trim();
        
        // Pattern pour détecter et supprimer l'ancienne date: (Maj : JJ/MM/AAAA HH:MM) au début
        cleanComment = cleanComment.replace(/^\(Maj\s*:\s*\d{2}\/\d{2}\/\d{4}\s+\d{2}:\d{2}\)\s*/i, '');
        
        // Créer la nouvelle date de mise à jour au format français
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const year = now.getFullYear();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        
        const datePrefix = `(Maj : ${day}/${month}/${year} ${hours}:${minutes})\n`;
        
        // Ajouter la nouvelle date au début du commentaire
        const commentWithDate = datePrefix + cleanComment;
        
        await updateProgramDocsComment(companyId, commentWithDate);
        
        // Mettre à jour le textarea avec le commentaire incluant la date
        this.docsCommentText = commentWithDate;
        
        (this as any).$vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Succès',
            text: 'Commentaire documents enregistré avec succès pour tous les programmes',
        });
    } catch (error) {
        console.error(error);
        
        (this as any).$vs.notify({
            color: 'danger',
            position: 'top-right',
            title: 'Erreur',
            text: 'Impossible d\'enregistrer le commentaire documents',
        });
    } finally {
        this.isSavingDocsComment = false;
    }
}
        
    }
